import { CanActivateFn, Router } from '@angular/router';
import { TokenService } from '../../services/token.service';
import { inject } from '@angular/core';

export const authGuard: CanActivateFn = (route, state) => {
  const tokenService = inject(TokenService);
  const router = inject(Router);

  return new Promise(async (resolve) => {   
    if (!tokenService.getAccesToken() || tokenService.refreshTokenExpired()) {
      tokenService.clearTokenWithCookie();
      router.navigate(['/login']);
      resolve(false)
    } else {
      resolve(true);
    }
  });
};
